import { css } from '@emotion/react';

export type TaskCardProps = {
  className?: string;
  head: string;
  children: React.ReactNode;
  variant: 'IPO' | 'M&A' | '内部統制構築' | '経営管理';
};

export const TaskCard: React.FC<TaskCardProps> = ({
  className,
  head,
  children,
  variant,
}) => {
  return (
    <div
      css={css`
        background: #fff;
        border-radius: 16px;
        padding: 32px 24px;
      `}
      className={className}
    >
      <h3
        css={css`
          text-align: center;
          font: normal normal bold 18px/26px 'Noto Sans JP', sans-serif;
          letter-spacing: 0.72px;
          margin-bottom: 20px;
          color: #ffffff;
          border-radius: 9999px;
          padding: 2px 0 4px;

          ${variant === 'IPO'
            ? css`
                background: #00C9BE;
              `
            : variant === 'M&A'
            ? css`
                background: #00C9BE;
              `
            : variant === '内部統制構築'
            ? css`
                background: #00B3A7;
              `
            : variant === '経営管理'
            ? css`
                background: #00B3A7;
              `
            : null}
        `}
      >
        {head}
      </h3>
      <ul
        css={css`
          display: flex;
          flex-direction: column;
          gap: 20px;
          flex-wrap: wrap;

          li {
            font: normal normal bold 16px/24px 'Noto Sans JP', sans-serif;
            letter-spacing: 0.32px;
            color: #5a5b6a;
            padding-left: 16px;
            position: relative;

            &::before {
              content: '';
              display: block;
              width: 9px;
              height: 9px;
              top: 8px;
              left: 0;
              background: #00b3a7;
              border-radius: 50%;
              position: absolute;
            }

            strong {
              color: #00b3a7;
              font-weight: inherit;
            }
          }
        `}
      >
        {children}
      </ul>
    </div>
  );
};
